var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2320",
    "data-name": "Group 2320",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.22,
    height: 51.22,
    viewBox: "0 0 51.22 51.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2945",
    "data-name": "Path 2945",
    d: "M0,0H51.22V51.22H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2946",
    "data-name": "Path 2946",
    d: "M1,4H47.952V8.268H1ZM1,33.879H47.952v4.268H1Zm39.743-6.586-.371-1.857h-4.16l-.662,1.842-3.334.006q3.217-7.7,4.772-11.414a1.456,1.456,0,0,1,1.462-.971q.813.006,2.657,0l2.576,12.389-2.941.006Zm-3.594-4.4h2.681l-1-4.653-1.677,4.653ZM15.666,14.9l3.351,0-5.18,12.391-3.393,0q-1.719-6.627-2.527-9.828a1.692,1.692,0,0,0-1.123-1.327q-.842-.288-2.806-.894V14.9H9.343a1.5,1.5,0,0,1,1.641,1.366l1.323,7.019L15.666,14.9Zm7.954,0L20.974,27.29l-3.191,0L20.43,14.9Zm6.471-.23a8.789,8.789,0,0,1,2.847.57l-.559,2.57a7.14,7.14,0,0,0-2.518-.576c-1.259.019-2.036.546-2.036,1.052,0,.82,1.349,1.234,2.74,2.132,1.586,1.024,1.793,1.942,1.774,2.941-.021,2.072-1.774,4.117-5.472,4.117a9.184,9.184,0,0,1-3.671-.653l.58-2.681a6.96,6.96,0,0,0,3.191.77c1.1,0,2.04-.442,2.049-1.212,0-.548-.331-.82-1.562-1.5s-2.956-1.613-2.934-3.5c.028-2.412,2.32-4.031,5.57-4.031Z",
    transform: "translate(1.134 4.537)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/visa-logo.496b59c3a5955c5aae62e55e02f542b1.svg";
export { ForwardRef as ReactComponent };